import BaseTransportSummary from './BaseTransportSummary'

import type { TrainItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TrainItem
}

function TrainItemSummary(props: Props) {
  return <BaseTransportSummary transportName="Train" {...props} />
}

export default TrainItemSummary
